<template>
    <div>
        <PageTitle :title="$t('perfil.titulo')" sectionClass="strech"/>
        <section class="padding-vertical-content">
            <div class="container">
                <div v-if="pedido" class="card p-4 shadow-sm">
                    <Stepper
                        ref="stepper"
                        :steps="steps" 
                    >
                        <template #pasoSeleccion="{ changeStep }">
                            <CambiarDatosPasoUno
                                :entradas="entradasSeleccionadas"
                                :pedido="pedido"
                                :esMovil="esMovil"
                                :coste_cambio_nombre="coste_cambio_nombre"
                                @terminado="entradas => { 
                                    entradasSeleccionadas = entradas; 
                                    changeStep(); 
                                }" 
                            />  
                        </template>

                        <template #pasoGestion="{ changeStep }">
                            <CambiarDatosPasoDos
                                :entradas="entradasSeleccionadas"
                                :esMovil="esMovil"
                                :coste_cambio_nombre="coste_cambio_nombre"
                                @volver="changeStep(true)"
                                @terminado="(entradas, payloadCarrito) => { 
                                    entradasSeleccionadas = entradas;
                                    guardarDatos(payloadCarrito); 
                                    changeStep(); 
                                }"
                            />
                        </template>
                        <template #pasoResumen="{ changeStep }">
                            <CambiarDatosPasoTres
                                :esMovil="esMovil"
                                :datosCompra="datosCompra"
                                :entradas="entradasSeleccionadas"
                                @volver="changeStep(true)"
                                @terminado="() => { 
                                    procesarCompra(); 
                                    changeStep(); 
                                }"
                            />
                        </template>
                        <template #pasoPago>
                            <CambiarDatosPasoCuatro 
                                :datosCompra="datosCompra"
                                :loading="loading"
                                :procesar_pago="procesar_pago"
                            />
                        </template>
                        <template #pasoFinal>
                            <h2>{{ $t('perfil.datos_entrada_cambiados', { entradas: manager.termino_entradas }) }}</h2>

                            <h4>{{ $t('perfil.info_entradas_modificadas', { entradas: manager.termino_entradas }) }}</h4>

                            <router-link
                                class="btn btn-primary btn-sm mt-2"
                                data-cy="volver-listado-pedidos"
                                to="/perfil?tab=pedidos"
                            >
                                {{ $t('perfil.volver_listado_pedidos') }}
                            </router-link>
                        </template>
                    </Stepper>
                </div>

                <div v-else class="text-center p-5">
                    <b-spinner variant="primary" label="Cargando..." />
                    <p class="mt-2">{{ $t('perfil.cargar_datos_pedido') }}</p>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import PageTitle from '@/components/frontend/shared/PageTitle';
    import Stepper from '@/components/frontend/events/compra/components/Stepper'; 
    import CambiarDatosPasoUno from '@/components/frontend/perfil/pedido/cambiar_datos/CambiarDatosPasoUno';
    import CambiarDatosPasoDos from '@/components/frontend/perfil/pedido/cambiar_datos/CambiarDatosPasoDos';
    import CambiarDatosPasoTres from '@/components/frontend/perfil/pedido/cambiar_datos/CambiarDatosPasoTres';
    import CambiarDatosPasoCuatro from '@/components/frontend/perfil/pedido/cambiar_datos/CambiarDatosPasoCuatro';

    export default {
        props: {
            tpv_order: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                pedido: null,
                loading: false,
                datosCompra: {},
                procesar_pago: false,
                urlCheckInterval: null,
                currentHref: window.location.href,
                entradasSeleccionadas: []
            }
        },
        methods: {
            getPedido() {
                const params = {
                    filters: {},
                    user_order_id: this.tpv_order
                }

                this.$store.dispatch(this.config.getVuexAlias('front.perfil.pedidos.detalle'), params).then(res => {
                    this.pedido = res.data.data;

                    if (this.pedido.evento.coste_cambio_nombre == '0.00' || !this.pedido.evento.solicitar_datos) {
                        this.$router.push('/perfil?tab=pedidos');
                    }
                });
            },
            guardarDatos(payloadCarrito) {
                const params = {
                    filters: {},
                    items: payloadCarrito
                }

                this.$store.dispatch(this.config.getVuexAlias('front.perfil.pedidos.carrito.crear'), params).then(res => {
                    this.datosCompra = {
                        session_id: res.data.session_id,
                        formulario: res.data.formulario,
                        jet_id: res.data.jet_id,
                        total_resumen: res.data.total,
                        coste_cambio_nombre: this.coste_cambio_nombre
                    }
                });
            },
            procesarCompra() {
                this.loading = true;

                setTimeout(() => {
                    this.$nextTick(() => {
                        this.scrollTo('#pago_loading');
                    });
                    this.procesar_pago = true;
                    this.loading = false;
                    this.$nextTick(() => {
                        this.scrollTo('#pago');
                    });
                }, 2000);
            },
            scrollTo(paso) {
                this.$scrollTo(paso, 100);
            }
        },
        computed: {
            coste_cambio_nombre() {
                return parseFloat(this.pedido?.evento.coste_cambio_nombre ?? 0);
            },
            esMovil() {
                return window.innerWidth <= 768;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            },
            hrefWatcher() {
                return this.currentHref;
            },
            manager() {
                return this.$store.getters.getFooter;
            },
            steps() {
                const steps = [
                    { label: this.$t('perfil.step_seleccionar_entradas'), slot: 'pasoSeleccion' },
                    { label: this.$t('perfil.step_modificar_datos'), slot: 'pasoGestion' },
                    { label: this.$t('perfil.step_resumen_compra'), slot: 'pasoResumen' },
                ]
                
                if (this.teatro?.tipo_tpv === 2) {
                    steps.push({ label: this.$t('perfil.step_datos_pago'), slot: 'pasoPago' });
                }

                steps.push({ label: this.$t('perfil.step_cambio_realizado'), slot: 'pasoFinal' });

                return steps;
            }
        },
        watch: {
            hrefWatcher(newHref, oldHref) {
                if (!oldHref.includes('pasoFinal') && newHref.includes('pasoFinal')) {
                    this.$nextTick(() => {
                        if (this.pedido && this.$refs.stepper) {
                            const finalStepIndex = this.steps.findIndex(step => step.slot === 'pasoFinal');
                            
                            if (finalStepIndex !== -1) {
                                this.$refs.stepper.currentStep = finalStepIndex + 1;
                            }

                            clearInterval(this.urlCheckInterval); 
                        }
                    });
                }
            }
        },
        created() {
            this.getPedido();
        },
        mounted() {
            this.urlCheckInterval = setInterval(() => {
                this.currentHref = window.location.href;
            }, 500);
        },
        beforeDestroy() {
            if (this.urlCheckInterval) {
                clearInterval(this.urlCheckInterval);
            }
        },
        components: {
            PageTitle, Stepper,
            CambiarDatosPasoUno, CambiarDatosPasoDos, CambiarDatosPasoTres, CambiarDatosPasoCuatro
        }         
    }
</script>